// Anonymous planner usage tracking. Never sends amounts, answers, plan codes or PII.
// Mirrors every event into GA4 (when configured) as diy_* custom events.
import { api } from "../../lib/api";
import { trackEvent } from "../../lib/analytics";

const SID_KEY = "oth_diy_sid";
const sentOnce = new Set();

const getSid = () => {
    try {
        let sid = sessionStorage.getItem(SID_KEY);
        if (!sid) {
            sid = Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
            sessionStorage.setItem(SID_KEY, sid);
        }
        return sid;
    } catch (e) {
        return "nosession-" + Math.random().toString(36).slice(2);
    }
};

const REPEATABLE = new Set(["excel_download", "pdf_download"]);

export const plannerTrack = (event, extra = {}) => {
    const dedupeKey = `${event}:${extra.step ?? ""}:${extra.section ?? ""}`;
    if (!REPEATABLE.has(event)) {
        if (sentOnce.has(dedupeKey)) return;
        sentOnce.add(dedupeKey);
    }
    const payload = {
        event,
        sid: getSid(),
        step: extra.step,
        section: extra.section,
        device: window.innerWidth < 768 ? "mobile" : "desktop",
    };
    api.post("/planner/track", payload).catch(() => {});
    trackEvent(`diy_${event}`, { step: extra.step, section: extra.section });
};
